import { render } from "./index.vue?vue&type=template&id=01ede264&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=01ede264&scoped=true&lang=css"

import exportComponent from "/home/runner/work/santo_cartao_adm_master/santo_cartao_adm_master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ede264"]])

export default __exports__